import { render } from "./HeroiconsOutlineDeviceTablet.vue?vue&type=template&id=3ba55ee0"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDeviceTablet.vue"]])

export default __exports__